require(["./common"], function(common) {
    return common;
});
define("main", function(){});

